/* 这是 0.0.1 版本的 scale-view。 */
/** 取小数后一位的四舍五入 */
function round(number, precision) {
  if (precision === void 0) {
    precision = 3;
  }
  return Math.round(+number + 'e' + precision) / Math.pow(10, precision);
}

var idealWidth = 750;
var maxWidth = 600;
var radio = maxWidth / idealWidth;

/**
 * 初始化
 * @param {number | null} width 理想宽度，视图将基于该宽度伸缩
 * @param {number | null} maxW 实际的最大宽度
 */
function init(width, maxW) {
  if (width === void 0) {
    width = idealWidth;
  }
  if (maxW === void 0) {
    maxW = maxWidth;
  }
  idealWidth = width;
  maxWidth = maxW;
  radio = maxWidth / idealWidth;
}

/**
 * 百分比和 vw 转换，常用于 fixed 定位的且包含块为浏览器窗口的元素
 * @param {number} n 
 * @param {string | null} unit "vw" or "%"
 */
function percentage(n, unit) {
  if (unit != null && !["vw", "%"].includes(unit)) return "" + n + unit;
  if (n === 0) return n;
  var maxN = round(maxWidth * n / 100);
  var pctUnit = unit || '%';
  var cssF = n > 0 ? "min" : "max";
  return cssF + "(" + n + pctUnit + ", " + maxN + "px)";
}

/**
 * vw 转换
 * @param {number} n 
 * @param {"px" | null} unit 单位
 */
function vw(n, unit) {
  if (unit != null && unit !== "px") return "" + n + unit;
  if (n === 0) return n;
  var vwN = round(n * 100 / idealWidth);
  return vwN + "vw";
}

/**
 * 限制大小的 vw 转换
 * @param {number} n 
 * @param {"px" | null} unit 单位
 */
function clampVw(n, unit) {
  if (unit != null && unit !== "px") return "" + n + unit;
  if (n === 0) return 0;
  var vwN = round(n * 100 / idealWidth);
  var maxN = round(n * maxWidth / idealWidth);
  var cssF = n > 0 ? "min" : "max";
  return cssF + "(" + vwN + "vw, " + maxN + "px)";
}

/**
 * 居中转换，用于 left 和 right 属性，且属性所在元素的包含块是浏览器窗口
 * @param {number} n 
 * @param {"vw" | "%" | "px" | null} unit 单位
 */
function centre(n, unit) {
  if (unit == null) return n;
  if (!["vw", "%", "px"].includes(unit)) return "" + n + unit;
  if (unit === "px") {
    var _calc = 50 - round(n * 100 / idealWidth);
    var _calc2 = round(maxWidth / 2 - n * radio);
    var _cssF = n > maxWidth / 2 ? "max" : "min";
    return "calc(50% - " + _cssF + "(" + _calc2 + "px, " + _calc + "%))";
  }

  // vw or %
  var calc = round(maxWidth * (50 - n) / 100);
  var calc2 = 50 - n;
  var cssF = n < 50 ? "min" : "max";
  return "calc(50vw - " + cssF + "(" + calc2 + unit + ", " + calc + "px))";
}

export { centre, clampVw, init, percentage, vw };
//# sourceMappingURL=scale-view.esm.js.map
